import { MoonOutlined, SunOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useThemeMode } from '@/app/theme/useThemeMode'

export function ThemeToggle() {
  const { t } = useTranslation()
  const { isDark, toggleMode } = useThemeMode()

  // Tugmada QARAMA-QARSHI rejim belgisi turadi — u nima qilishini
  // ko'rsatadi, hozir qaysi rejimda ekanini emas
  const label = isDark ? t('theme.light') : t('theme.dark')

  return (
    <Tooltip title={label}>
      <Button
        type="text"
        aria-label={label}
        icon={isDark ? <SunOutlined /> : <MoonOutlined />}
        onClick={toggleMode}
      />
    </Tooltip>
  )
}
